/**
 * Ouverture de l'IMPORT des évaluations nationales par le professeur délégué.
 * Fermé le 2026-09-14 (« Bientôt disponible »), ROUVERT le 2026-10-09 (décision
 * prof : c'est le délégué qui importe). Le chef importe toujours ; un professeur
 * qui n'est pas délégué n'importe jamais : il consulte les résultats importés et
 * fait passer ses évaluations bilan.
 *
 * Même mécanique que `generators/ouverture.js` : refermer = passer le drapeau à
 * `false`, rien d'autre à toucher.
 */
export const IMPORT_NATIONALES_DELEGUE_OUVERT = true;

export const MENTION_IMPORT_NATIONALES_A_VENIR = 'Bientôt disponible';

/**
 * L'import des nationales est-il ouvert à cet utilisateur ?
 * Le chef importe toujours ; un professeur DÉLÉGUÉ dépend du drapeau ; tout autre
 * professeur, jamais, même drapeau ouvert (la page d'import se joint par son
 * adresse : le menu ne suffit pas à la fermer).
 * @param {{role?: string}|null|undefined} user
 * @param {boolean} estDelegue - le professeur a une affectation de délégué
 * @param {boolean} [ouvert] - le drapeau (paramètre pour les tests)
 */
export const importNationalesOuvert = (user, estDelegue, ouvert = IMPORT_NATIONALES_DELEGUE_OUVERT) =>
    user?.role === 'chef' || (ouvert && estDelegue === true);
